import React from "react";
import "./EditProfile.css";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import EditProfileLayout
 from "../layouts/Employee/EditProfileLayout";

export default function EditProfile() {
  return (
    <>
      <Header />
      <SubHeader />
      <EditProfileLayout />
    </>
  );
}
